const datasetStatusActions = {
  FETCH_DATASET_STATUS: 'FETCH_DATASET_STATUS',
  FETCH_DATASET_STATUS_ERROR: 'FETCH_DATASET_STATUS_ERROR',
  FETCH_DATASET_STATUS_SUCCESS: 'FETCH_DATASET_STATUS_SUCCESS',
};

export const datasetStatusIcons = {
  queryable: 'filter',
  requestable: 'key',
  conditions: 'clipboard list',
};

export default datasetStatusActions;
